import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import TopRightPrevArrow from "./TopRightPrevArrow";
import TopRightNextArrow from "./TopRightNextArrow";
const TopRightArrowsGroup = ({ onPrev, onNext, topOffset, arrowColor })=>/*#__PURE__*/ _jsxs("div", {
        className: "carousel-arrows-edge-group",
        style: {
            top: topOffset
        },
        children: [
            /*#__PURE__*/ _jsx(TopRightPrevArrow, {
                onClick: onPrev,
                color: arrowColor
            }),
            /*#__PURE__*/ _jsx(TopRightNextArrow, {
                onClick: onNext,
                color: arrowColor
            })
        ]
    });
export default TopRightArrowsGroup;
